import { CALL_API } from '../middleware/api';

export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';


export function loadUser(token) {
  const tokenUrl = (token !== undefined) ? '?token=' + token : '';
  console.log(tokenUrl);
  return {
    [CALL_API]: {
      types: [USER_REQUEST, USER_SUCCESS, USER_FAILURE],
      endpoint: 'login/getuser/' + tokenUrl,
      errHandle: false
    }
  };
}
export default (token) => {
  return (dispatch, getState) => {
    return dispatch(loadUser(token));
  };
};


// WEBPACK FOOTER //
// ./src/action/loadUser.js